import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import "../../assets/styles/local/Project.css";
import "../../assets/styles/local/ProjectList.css";
import moment from "moment";
import deleteIcon from "../../assets/icons/Bin.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchProject,
  FetchProjectBB,
  DeleteProject,
} from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ProjectList = ({ query, setShowLoader, shortByArrow, sortedValue }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const fetchProjectBB = useSelector((state) => state.user.fetchProjectBB);
  const deleteProjectRes = useSelector((state) => state.user.deleteProjectRes);

  const companyId = window.localStorage.getItem("companyid");
  const roleid = window.localStorage.getItem("roleid");
  const fetchProject = useSelector((state) => state.user.fetchProject);

  const [listData, setListData] = useState([]);

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const main = getAppSideNavOptions.some(
        (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(main);
      if (main === true) {
        // dispatch(FetchProjectBB(companyId, process.env.REACT_APP_IS_PREMIUM));

        let data = shortByArrow
          ? "Asc" + "-" + sortedValue
          : "Dsc" + "-" + sortedValue;

        const data2 = shortByArrow
          ? `Ascending-${sortedValue}`
          : `Descending-${sortedValue}`;

        dispatch(
          FetchProjectBB(companyId, data, process.env.REACT_APP_IS_PREMIUM),
        );
      } else {
        dispatch(FetchProject(companyId));
      }
    }
  }, [shortByArrow, sortedValue, deleteProjectRes]);

  const processProjectData = (data) =>
    data?.data &&
    data.status === true &&
    data.data[0] &&
    data.data[0].projectstatus &&
    Array.isArray(data.data[0].projectstatus)
      ? data.data[0].projectstatus
      : [];

  useEffect(() => {
    if (isBuildingBlock) {
      setListData(processProjectData(fetchProjectBB));
      setShowLoader(false);
    } else {
      setListData(processProjectData(fetchProject));
      setShowLoader(false);
    }
  }, [
    fetchProjectBB,
    fetchProject,
    isBuildingBlock,
    fetchProjectBB?.data,
    fetchProject?.data,
  ]);

  //functionality of radio button show color
  const getPriorityColor = (priorityid) => {
    switch (priorityid) {
      case "08da8a3e-d43a-40b9-845d-ba8c2e749692":
        return "green"; // High priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749693":
        return "yellow"; // Low priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749694":
        return "orange"; // Medium priority
      default:
        return "white"; // Default priority
    }
  };

  const [projectListTranslation, setProjectListTranslation] = useState({});
  const t = (key) => projectListTranslation?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Project-List").then((res) => {
      setProjectListTranslation(res);
    });
  }, []);

  return (
    <div className="container-fluid project_List_Parent mt-3 px-4">
      <div className="table-responsive">
        <table className="table table-hove-r">
          <thead className="custom-thead">
            <tr>
              {/* <th style={{ width: "10%" }}>Project ID</th> */}
              <th style={{ width: "10%" }}>
                {/* Project ID */}
                {t("Project Id")}
              </th>
              <th style={{ width: "25%" }}>
                {/* Project Name */}
                {t("Project Name")}
              </th>
              <th style={{ width: "25%" }}>
                {/* Client */}
                {t("Client")}
              </th>
              <th style={{ width: "25%" }}>
                {/* Work Address */}
                {t("Work Address")}
              </th>
              <th style={{ width: "15%" }}>
                {/* Project Manager */}
                {t("Project Manager")}
              </th>
              <th style={{ width: "10%" }}>
                {/* Completion Date */}
                {t("Completion Date")}
              </th>
              <th style={{ width: "15%", display: "none" }}>
                {/* Assig. Probability */}
                {t("Assig. Probability")}
              </th>
            </tr>
          </thead>
          <tbody
            className="project_List_body"
            style={{ border: "none !important" }}
          >
            {listData?.map((items, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td
                    colSpan="12"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <p
                      className="fw-bold"
                      style={{
                        color: "#333333",
                        fontSize: "12px",
                        height: "4px",
                      }}
                    >
                      {items.statusname}
                    </p>
                  </td>
                </tr>
                {items?.projectdetails
                  ?.filter(
                    (item) =>
                      item.projectcode
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      item.projectname
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      item.clientname
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      item.projectmanagername
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      item.projectdescription
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()),
                  )
                  // ?.sort((a, b) => a.projectname.localeCompare(b.projectname))
                  ?.map((item, index) => (
                    <tr key={index} className="align-middle Project_Row_Table">
                      <td
                        className="d-flex gap-3"
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                      >
                        <p className="mb-0" style={{ width: "70px" }}>
                          {item.projectcode}
                        </p>

                        <div
                          className="custom-radio"
                          style={{
                            "--color": getPriorityColor(item.priorityid),
                          }}
                        >
                          <input
                            type="radio"
                            id={`priority-${item.priorityid}`}
                            name="priority"
                            value={item.priorityid}
                          />
                          <label htmlFor={`priority-${item.priorityid}`}>
                            <span className="radio-circle"></span>{" "}
                            {/* {item.priorityname} */}
                          </label>
                        </div>
                      </td>
                      <td
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                      >
                        {item.projectname.length > 30
                          ? item.projectname.slice(0, 30) + "..."
                          : item.projectname}
                      </td>
                      <td
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                        title={item?.clientname}
                      >
                        {item?.clientname?.length > 30
                          ? item?.clientname?.slice(0, 30) + "..."
                          : item?.clientname}
                      </td>
                      <td
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                        title={item?.deliveryAddress}
                      >
                        {item?.deliveryAddress?.length > 30
                          ? item?.deliveryAddress?.slice(0, 30) + "..."
                          : item?.deliveryAddress}
                      </td>
                      <td
                        className="d-flex align-items-center"
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                      >
                        {item.projectmanagerimage ? (
                          <img
                            src={item.projectmanagerimage}
                            alt=""
                            className="rounded-circle me-2"
                            style={{ width: "30px", height: "30px" }}
                          />
                        ) : (
                          <div
                            className="me-2"
                            style={{
                              width: "30px",
                              height: "30px",
                              background: "#95A7C6",
                              color: "#FFFFFF",
                              fontSize: "14px",
                              borderRadius: "50%",
                              textAlign: "center",
                              paddingTop: "4px",
                            }}
                          >
                            <p>
                              {(() => {
                                const projectmanagername =
                                  item.projectmanagername || "";
                                const nameParts = projectmanagername
                                  .trim()
                                  .split(" ");
                                const initials = nameParts
                                  .map((word) => word[0]?.toUpperCase())
                                  .join("");
                                return initials || "--"; // Default fallback
                              })()}
                            </p>
                          </div>
                        )}

                        {item.projectmanagername}
                      </td>
                      <td
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                      >
                        <div className="d-flex">
                          {moment(item.completiondate).format("DD.MM.YYYY")}
                          {roleid ===
                            "08da3f0d-0371-4dd3-8c86-e51222d56188" && (
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(
                                  DeleteProject({ projectid: item.projectid }),
                                );
                              }}
                              src={deleteIcon}
                              className="card-plus-img ms-auto me-3"
                              style={{ width: "14px" }}
                              alt=""
                            />
                          )}
                        </div>
                      </td>
                      <td
                        className="gap-3 d-none"
                        onClick={() => {
                          window.localStorage.setItem(
                            "projectid",
                            item.projectid,
                          );
                          history.push(
                            `/project/${item.projectid}/${item.projectcode}`,
                          );
                        }}
                      >
                        <div
                          className="custom-radio"
                          style={{
                            "--color": getPriorityColor(item.priorityid),
                          }}
                        >
                          <input
                            type="radio"
                            id={`priority-${item.priorityid}`}
                            name="priority"
                            value={item.priorityid}
                          />
                          <label htmlFor={`priority-${item.priorityid}`}>
                            <span className="radio-circle"></span>{" "}
                            {item.priorityname}
                          </label>
                        </div>
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default ProjectList;
